import { useCallback } from 'react';
import { di } from 'react-magnetic-di';
import { set as setQueryParams } from '@atlassian/help-center-common-util/history-qs';
import { clearSidebarExperienceAndCustomize } from '@atlassian/help-center-common-util/sidebar-experience';
import { useQueryParams } from 'view/search/common';

export type HubCustomizationExperience = 'login-announcement';

export const useHubCustomizationSidebar = (experience: HubCustomizationExperience) => {
	di(useQueryParams, setQueryParams, clearSidebarExperienceAndCustomize);
	const queryParams = useQueryParams() as Record<string, unknown>;
	const isOpen = queryParams.customize === 'true' && queryParams.experience === experience;

	const openFromMenu = useCallback(() => {
		setQueryParams({ experience, customize: 'true' }, false);
	}, [experience]);

	const close = useCallback(() => {
		clearSidebarExperienceAndCustomize();
	}, []);

	return { isOpen, openFromMenu, close };
};
